import { Languages } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { useLanguage } from '../../i18n/language.js';

/**
 * The public chrome for the pre-authentication Business Profile preview:
 * the Mouja mark and the language switch, nothing else.
 *
 * A signed-in merchant never sees this. Their routes compose inside
 * `MerchantWorkspaceShell`, whose sidebar owns navigation, language, and
 * sign-out — so there is no second navigation bar to hide.
 */
export function MerchantPublicHeader(): ReactNode {
  const { language, toggle } = useLanguage();
  const isArabic = language === 'ar';
  return (
    <header className="mj-merchant-public-header">
      <Link
        to="/"
        className="mj-merchant-public-brand"
        aria-label={isArabic ? 'موجة — الصفحة الرئيسية' : 'Mouja — home'}
      >
        <img
          src={
            isArabic
              ? '/mouja-arabic-pixel-media-logo.svg'
              : '/mouja-pixel-media-logo.svg'
          }
          alt=""
        />
      </Link>
      <button
        type="button"
        className="mj-merchant-public-language"
        lang={isArabic ? 'en' : 'ar'}
        onClick={toggle}
      >
        <Languages aria-hidden="true" strokeWidth={1.8} />
        <span>{isArabic ? 'English' : 'العربية'}</span>
      </button>
    </header>
  );
}
